export enum ApplicationDetailsTabs {
  Settings = 'settings',
  AdvancedSettings = 'advanced-settings',
  Roles = 'roles',
  Logs = 'logs',
}

export enum ApiResourceDetailsTabs {
  Settings = 'settings',
  Permissions = 'permissions',
}

export enum ConnectorsTabs {
  Passwordless = 'passwordless',
  Social = 'social',
}

export enum WebhookDetailsTabs {
  Settings = 'settings',
  RecentRequests = 'recent-requests',
}

export enum UserDetailsTabs {
  Settings = 'settings',
  Roles = 'roles',
  Logs = 'logs',
  Organizations = 'organizations',
}

export enum RoleDetailsTabs {
  Settings = 'settings',
  Permissions = 'permissions',
  Users = 'users',
  M2mApps = 'machine-to-machine-apps',
}

export enum TenantSettingsTabs {
  Settings = 'settings',
  Domains = 'domains',
  Subscription = 'subscription',
  BillingHistory = 'billing-history',
}

export enum EnterpriseSsoDetailsTabs {
  Connection = 'connection',
  Experience = 'experience',
}
